module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n	<div class="body__header">\n		<div class="body-header__title">List of events</div>\n		<div class="body-header__options">\n\n		</div>\n	</div>\n	<div class="body__content device-events__region "></div>\n\n\n\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/device-events/show/templates/layout.html
// module id = 422
// module chunks = 0